import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useLanguage } from "@/contexts/LanguageContext";
import Timeline from "@/components/about/Timeline";

const About = () => {
  const { ref: sectionRef, isVisible } = useScrollAnimation(0.2);
  const { t } = useLanguage();

  return (
    <section id="about" className="section-padding bg-card" ref={sectionRef}>
      <div className="container-custom">
        <div className={`text-center mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-gold text-lg font-medium tracking-wider uppercase mb-4 animate-text-glow">{t('about.title')}</p>
          <h2 className="heading-luxury text-foreground mb-6 text-gradient">
            {t('about.heading')}
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            {t('about.description')}
          </p>
        </div>

        <Timeline />

        <div className={`mt-16 p-12 bg-gradient-to-r from-gold/10 to-burgundy/10 rounded-2xl border border-gold/20 transition-all duration-700 ${
          isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
        }`} style={{ transitionDelay: '0.6s' }}>
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-xl text-foreground leading-relaxed italic font-serif">
              {t('about.quote')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
